import request from './http'
import { CAMPANIAS_ENDPOINT } from '../infrastructure/appConstants'

const campaniaService = {
    listCampanias: () => request.get(`${CAMPANIAS_ENDPOINT}/campania/listar`),
    notificarSectorista: (req) => request.post(`${CAMPANIAS_ENDPOINT}/sectorista/notificar`, req)
}

export default campaniaService
